import { useQuery } from '@apollo/client';
import { QGlobalDataQuery } from '../graphql';
import { prop, propOr } from 'ramda';

export const useGlobalData = () => {
  const {
    data,
    loading: loadingGlobalData
  } = useQuery(QGlobalDataQuery);
  const {
    getJobs,
    getProfessionalSituations,
    getSocioProfessionalCategories,
    getActivities,
    getRegimeObligatoire,
    getInsurances,
    getFamilySituations,
    getOrganismCodes,
    getPhoneIndicatives,
    getActiveUserInformation,
    getViewMode,
    getProductCode,
    getAnalyticsInformation,
    getUsersInformation,
    getProject
  } = data || {};

  return {
    jobs: prop('data', getJobs),
    professionalSituations: prop('data', getProfessionalSituations),
    socioProfessionalCategories: prop('data', getSocioProfessionalCategories),
    activities: prop('data', getActivities),
    regimeObligatoire: prop('data', getRegimeObligatoire),
    insurances: prop('data', getInsurances),
    familySituations: prop('data', getFamilySituations),
    organismCodes: prop('data', getOrganismCodes),
    phoneIndicatives: prop('data', getPhoneIndicatives),
    productCode: propOr('', 'productCode', getProductCode),
    activeUserInformation: propOr({}, 'data', getActiveUserInformation),
    analyticsInformation: propOr({}, 'data', getAnalyticsInformation),
    usersInformation: propOr([], 'data', getUsersInformation),
    viewMode: prop('viewMode', getViewMode),
    getProject: propOr({}, 'data', getProject),
    loadingGlobalData
  };
};
